export const SET_USER = 'SET_USER';
export const CLEAR = 'CLEAR';
export const SET_IS_AUTH = 'SET_IS_AUTH';
